import useTranslation from 'next-translate/useTranslation';

import { Box, Grid, InputNumberControl, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useLanguage } from '@core/hook';
import { CreateProductAlertForm, UpdateProductAlertForm } from '@core/type';
import { formatCurrency } from '@core/util';

import { LineModalAlertField } from '../interface-modal-alert';

export const LineProductAlertField = <T extends CreateProductAlertForm | UpdateProductAlertForm>({
  watch,
  control,
  product,
  errors,
}: LineModalAlertField<T>) => {
  const { t: tProduct } = useTranslation(Translate.common.PRODUCT);
  const { t: tForm } = useTranslation(Translate.common.FORM);
  const { language } = useLanguage();
  const { isPhone } = useContextMediaQuery();
  const formAmount = watch('amount') as number;

  return (
    <Grid isContainer>
      <Grid xs={6}>
        <Typography marginBottom={isPhone ? '0' : '32px'}>
          {tProduct('modals.addPriceAlert.currentPrice')}
        </Typography>
        <Typography>{formatCurrency(language, product.currencyIso, product.totalPrice)}</Typography>
      </Grid>
      <Grid xs={6}>
        <Typography marginBottom={'16px'}>{tProduct('modals.addPriceAlert.yourPrice')}</Typography>
        <Box display="flex" justifyContent="center" flexDirection="column">
          <InputNumberControl
            control={control}
            name="amount"
            required
            label={tProduct('modals.addPriceAlert.pricePlaceholder')}
            isError={!!errors['amount']}
            message={(isNaN(formAmount) || formAmount < 1) && tForm('amount.validate.typeError')}
            fractionDigits={2}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
